import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';

export default function ExportReportModal({
	show,
	onHide,
	exportTheme,
	setExportTheme,
	onExport,
	isExporting,
}) {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>Export Report</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3">
					<Form.Label>Theme (PDF only)</Form.Label>
					<ButtonGroup className="w-100">
						<Button
							variant={exportTheme === 'dark' ? 'primary' : 'outline-secondary'}
							onClick={() => setExportTheme('dark')}>
							🌙 Dark
						</Button>
						<Button
							variant={exportTheme === 'light' ? 'primary' : 'outline-secondary'}
							onClick={() => setExportTheme('light')}>
							☀️ Light
						</Button>
					</ButtonGroup>
				</Form.Group>

				<Form.Group>
					<Form.Label>Export Format</Form.Label>
					<div className="d-grid gap-2">
						<Button
							variant="success"
							style={{ backgroundColor: '#14743B', borderColor: '#14743B' }}
							onClick={() => onExport('pdf')}
							disabled={isExporting}>
							📄 Export as PDF
						</Button>
						<Button
							variant="outline-primary"
							onClick={() => onExport('docx')}
							disabled={isExporting}>
							📝 Export as DOCX
						</Button>
					</div>
				</Form.Group>
			</Modal.Body>
		</Modal>
	);
}
